'use strict';



function __$styleInject(css) {
    if (!css) return;

    if (typeof window == 'undefined') return;
    var style = document.createElement('style');
    style.setAttribute('media', 'screen');

    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var DocsConfig = _interopDefault(require('@tencent/docs-config'));
var $ = _interopDefault(require('jquery'));
var React = require('react');
var React__default = _interopDefault(React);
var ReactDOM = _interopDefault(require('react-dom'));
var tencentDocReport = require('@tencent/tencent-doc-report');

/**
 * 将所有的cac整改配置收拢到该文件，将代码里的写死域名之类的也收拢到该文件，在此集中disable相关eslint
 */
var appConfigInstance = DocsConfig.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/image-components"]');
var Qqadapt = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.Qqadapt) || 'qqadapt.qpic.cn';
var LOCATION_HOST = window.location.host; // 修改host规范化，修改取值
var PUB_ORIGIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.PUB_ORIGIN) || 'https://pub.idqqimg.com';
var SDK_JS_URL = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.SDK_JS_URL) || 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
var wechatSignatureUrl = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.wechatSignatureUrl) || '//docs.qq.com/v2/util/wechat/signature';

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
var ImageUtil = /** @class */ (function () {
    function ImageUtil() {
    }
    /**
     *  https://qqadapt.qpic.cn/txdocpic/0/f03163cb12f62a4c32d056d81fb55f89/0   原图
        https://qqadapt.qpic.cn/txdocpic/0/f03163cb12f62a4c32d056d81fb55f89/20000    20000规格
        https://qqadapt.qpic.cn/txdocpic/0/f03163cb12f62a4c32d056d81fb55f89/1600      1600规格
        https://qqadapt.qpic.cn/txdocpic/0/f03163cb12f62a4c32d056d81fb55f89/1123      1123规格
     * @param url
     */
    // 4096*4096
    ImageUtil.getImageThumb20000 = function (url) {
        if (!this.isValidQqadaptDomain(url)) {
            return url;
        }
        return url.substring(0, url.length - 1) + '20000';
    };
    // 1123*1588
    ImageUtil.getImageThumb1123 = function (url) {
        if (!this.isValidQqadaptDomain(url)) {
            return url;
        }
        return url.substring(0, url.length - 1) + '1123';
    };
    // 1600*900
    ImageUtil.getImageThumb1600 = function (url) {
        if (!this.isValidQqadaptDomain(url)) {
            return url;
        }
        return url.substring(0, url.length - 1) + '1600';
    };
    ImageUtil.isValidQqadaptDomain = function (url) {
        if (!url || url.length < 1) {
            return false;
        }
        return url.indexOf(Qqadapt) > 0;
    };
    ImageUtil.randomString = function (groups) {
        var count = groups || 4;
        var randomstring = '';
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        for (var i = 0; i < count; i++) {
            randomstring += s4();
        }
        return randomstring;
    };
    ImageUtil.getAttachmentId = function () {
        return +new Date() + '-' + this.randomString();
    };
    // 目前只支持 png
    ImageUtil.getImageSize = function (base64) {
        //确认处理的是png格式的数据
        if (base64.substring(0, 22) !== 'data:image/png;base64,') {
            return { width: 0, height: 0 };
        }
        // 截取base64中包含宽高信息的12个字符，这12字符转成9个字节中的后8个字节代表宽高
        var data = base64.substring(42, 54);
        var base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var nums = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var c = data_1[_i];
            nums.push(base64Chars.indexOf(c));
        }
        var bytes = [];
        // 四个数字转为三个数字表示
        for (var i = 0; i < nums.length; i += 4) {
            bytes.push((nums[i] << 2) + (nums[i + 1] >> 4));
            bytes.push(((nums[i + 1] & 15) << 4) + (nums[i + 2] >> 2));
            bytes.push(((nums[i + 2] & 3) << 6) + nums[i + 3]);
        }
        var width = (bytes[1] << 24) + (bytes[2] << 16) + (bytes[3] << 8) + bytes[4];
        var height = (bytes[5] << 24) + (bytes[6] << 16) + (bytes[7] << 8) + bytes[8];
        return { width: width, height: height };
    };
    ImageUtil.isBase64 = function (url) {
        if (!url || typeof url !== 'string') {
            return false;
        }
        return url.startsWith('data:image/');
    };
    ImageUtil.dataURLToBlob = function (dataURI) {
        // convert base64 to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        }
        else {
            byteString = unescape(dataURI.split(',')[1]);
        }
        // separate out the mime component
        var mimeString = dataURI
            .split(',')[0]
            .split(':')[1]
            .split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };
    return ImageUtil;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/*
 * File: /src/base/util/predicates.ts
 * Project: melo
 * Created Date: Wednesday September 26th 2018
 * Author: billbai(白银峰)
 * -----
 * Copyright (c) 2018 Tencent
 */
/**
 * Checks if the given argument is undefined.
 * @function
 */
function isUndefined(obj) {
    return typeof obj === 'undefined';
}

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
/**
 * log输出代理接口，后续接入其他log模块直接在这里进行
 */
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.log = function (msg) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Logger.logHandler) {
            (_a = Logger.logHandler).log.apply(_a, __spreadArrays([msg], args));
        }
        else {
            console.log.apply(console, args);
        }
    };
    Logger.debug = function (msg) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Logger.logHandler) {
            (_a = Logger.logHandler).debug.apply(_a, __spreadArrays([msg], args));
        }
    };
    Logger.info = function (msg) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Logger.logHandler) {
            (_a = Logger.logHandler).info.apply(_a, __spreadArrays([msg], args));
        }
    };
    Logger.warn = function (msg) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Logger.logHandler) {
            (_a = Logger.logHandler).warn.apply(_a, __spreadArrays([msg], args));
        }
    };
    Logger.error = function (msg) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Logger.logHandler) {
            (_a = Logger.logHandler).error.apply(_a, __spreadArrays([msg], args));
        }
    };
    Logger.raven = function (data) {
        if (window) {
            return window.raven(data);
        }
        return data;
    };
    Logger.time = function (label) {
        if (!isUndefined(console)) {
            console.time(label);
        }
    };
    Logger.timeEnd = function (label) {
        if (!isUndefined(console)) {
            console.timeEnd(label);
        }
    };
    Logger.logHandler = window.log;
    return Logger;
}());

var versionRegExp = /\d+([._]\d+)*/;
var namedVersionRegExp = function (name) { return new RegExp("\\b".concat(name, "\\W+\\d+([\\._]\\d+)*"), 'i'); };
/**
 * 从字符串中取出连续的数字和小数点/下划线作为版本号
 * - 始终取字符串中第一段有数字和小数点/下划线（可以没有小数点/下划线）的连续子串，忽略其他字符
 * - 将下划线转换成小数点
 * - 如果字符串中根本没有数字，返回 null
 * @param versionString 可能含有版本号的字符串
 */
function normalizeVersion(versionString) {
    var _a;
    var match = versionRegExp.exec(versionString);
    return (_a = match === null || match === void 0 ? void 0 : match[0].replace(/_/g, '.')) !== null && _a !== void 0 ? _a : null;
}
/**
 * 版本号转换为整数列表
 * - 始终取字符串中第一段有数字和小数点/下划线（可以没有小数点/下划线）的连续子串，忽略其他字符
 * - 如果字符串中根本没有数字，返回空列表
 * - 由小数点/下划线隔开的每一段数字当作整数处理，例如 1.02 中的 02 当作 2 处理
 * - 末尾如果有 0 会被保留，例如 3.0.0 -> [3, 0, 0]
 * @param version 版本号
 */
function versionToList(versionString) {
    var version = normalizeVersion(versionString);
    return (version === null || version === void 0 ? void 0 : version.split('.').map(Number)) || [];
}
/**
 * 比较两个整数列表
 * @param list1 第一个数字列表
 * @param list2 第二个数字列表
 * @returns -1(list1<list2) | 0(list1=list2) | 1(list1>list2)
 */
function compareList(list1, list2) {
    var result = Array(Math.max(list1.length, list2.length))
        .fill(0)
        .map(function (_, i) { return (list1[i] || 0) - (list2[i] || 0); })
        .find(function (k) { return k !== 0; }) || 0;
    if (result < 0)
        return -1;
    if (result > 0)
        return 1;
    return 0;
}
/**
 * 比较两个版本号字符串
 * - 始终取字符串中第一段有数字和小数点/下划线（可以没有小数点/下划线）的连续子串，忽略其他字符
 * - 如果字符串中根本没有数字，当作 0 版本处理
 * - 由小数点/下划线隔开的每一段数字当作整数处理，例如 1.02 和 1.2 是一样的，请注意适用范围
 * - 末尾有 .0 会被忽略，例如 2 = 2.0 = 2.0.0
 * @param ver1 第一个版本号字符串
 * @param ver2 第二个版本号字符串
 * @returns -1(ver1<ver2) | 0(ver1=ver2) | 1(ver1>ver2)
 */
function compareVersion(ver1, ver2) {
    return compareList(versionToList(ver1), versionToList(ver2));
}
/**
 * 从 userAgent 中取出以某前缀后面（可以隔一个符号，例如空格或者斜杠）出现的版本号
 * - 在前缀之前没有出现字母数字，才会匹配
 * - 前缀不区分大小写，例如 micromessenger 可以匹配 MicroMessenger/6.2
 * - 如果找不到或者后面根本没有数字，返回 null
 * @param prefix 要提取的平台前缀，例如 MicroMessenger
 * @param ua 原始 userAgent
 */
function getVersionFromUA(prefix, ua) {
    var regExp;
    try {
        regExp = namedVersionRegExp(prefix);
    }
    catch (e) {
        return null;
    }
    var match = regExp.exec(ua);
    if (!match)
        return null;
    return normalizeVersion(match[0].substring(prefix.length));
}
/** 从环境中获取 User Agent. */
var getUserAgent = /* #__PURE__ */ (function () {
    var userAgent;
    return function () {
        // 服务端渲染不会提供 window，会提供 global 供兼容 - sigma
        if (userAgent === undefined) {
            userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
        }
        return userAgent;
    };
})();
// 下面一系列函数将第一个参数是 userAgent 的函数, 转换为支持自动获取的, 并将 userAgent 移到末尾.
// 这种固定参数的写法在运行时速度最快, 包体积最小, 但是有一些魔法和类型体操, 不懂勿改.
function withDefaultUA(fn) {
    return function (userAgent) {
        return fn(userAgent || getUserAgent());
    };
}
function withDefaultUAAndVersion(fn) {
    return function (version, userAgent) {
        return fn(userAgent || getUserAgent(), version);
    };
}

/* eslint-disable max-len */
/**
 * 是否是 Electron 客户端
 */
var isElectronTencentDocsClient = /* #__PURE__ */ withDefaultUA(function (userAgent) {
    return /TDAppDesktop/i.test(userAgent);
});
/**
 * 获取腾讯文档 Electron 客户端版本
 */
var getElectronTencentDocsClientVersion = /* #__PURE__ */ withDefaultUA(function (userAgent) {
    return getVersionFromUA('TDAppDesktop', userAgent);
});
/**
 * 判断腾讯文档 Electron 客户端是否高于指定的版本
 */
var isElectronTencentDocsClientVersionAboveOrEqual = /* #__PURE__ */ withDefaultUAAndVersion(function (userAgent, version) {
    return compareVersion(getElectronTencentDocsClientVersion(userAgent) || '', version) >= 0;
});

(function (UploadUsage) {
    UploadUsage[UploadUsage["USAGE_UNSPECIFIED"] = 0] = "USAGE_UNSPECIFIED";
    UploadUsage[UploadUsage["USAGE_DOCUMENT_BODY"] = 1] = "USAGE_DOCUMENT_BODY";
    UploadUsage[UploadUsage["USAGE_DOCUMENT_SNAPSHOT"] = 2] = "USAGE_DOCUMENT_SNAPSHOT";
    UploadUsage[UploadUsage["USAGE_VIDEO_SNAPSHOT"] = 3] = "USAGE_VIDEO_SNAPSHOT";
    UploadUsage[UploadUsage["USAGE_FILLIN_FORM"] = 4] = "USAGE_FILLIN_FORM";
})(exports.UploadUsage || (exports.UploadUsage = {}));
(function (CustomizeUploadImageFileErrorCode) {
    CustomizeUploadImageFileErrorCode[CustomizeUploadImageFileErrorCode["NetWorkStatusError"] = -11] = "NetWorkStatusError";
    CustomizeUploadImageFileErrorCode[CustomizeUploadImageFileErrorCode["CatchError"] = -12] = "CatchError";
    CustomizeUploadImageFileErrorCode[CustomizeUploadImageFileErrorCode["OnError"] = -13] = "OnError";
    CustomizeUploadImageFileErrorCode[CustomizeUploadImageFileErrorCode["OnTimeout"] = -14] = "OnTimeout";
})(exports.CustomizeUploadImageFileErrorCode || (exports.CustomizeUploadImageFileErrorCode = {}));
/**
 * 默认图片上传地址.
 *
 * 2023 容量收费需求的前置技术需求中, 要求将图片上传地址切换为带容量判断的上传地址.
 * 但由于桌面端 < 3.1.14 版本中本地编辑能力会固定拦截旧的图片上传地址,
 * 因此决定对于旧版本桌面端不切换图片上传地址. 其它所有端均使用新上传地址.
 *
 * - [需求单](https://tapd.woa.com/10143861/prong/stories/view/1010143861115415274)
 * - [需求相关表格](https://doc.weixin.qq.com/sheet/e3_AbcA4Aa8AEAJYWjcwp5TvqO3Tx2Qv?scode=AJEAIQdfAAozyS6P90AP8AKgaCACc&tab=ss_1f0wy0&viewId=vPJj2f)
 */
var DEFAULT_UPLOAD_URL = (!isElectronTencentDocsClient() || isElectronTencentDocsClientVersionAboveOrEqual('3.1.14')
    ? '/api/docsdata/image/upload'
    : '/v1/image/upload');

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
var ImageUploader = /** @class */ (function () {
    function ImageUploader() {
    }
    ImageUploader.tryGetImageInnerURLByTaskID = function (imageSrc, attachmentId, taskID, reqInterval, reqCounter, sucCallback, errorCallback, xsrf) {
        Logger.info('_tryGetImageInnerURLByTaskID: imageSrc: ' + imageSrc + ',attachmentId: ' + attachmentId + ',taskID: ' + taskID + ',reqCounter: ' + reqCounter);
        var fetchImageInnerURL = 'https://' + LOCATION_HOST
            + '/cgi-bin/online_docs/upload_query?key=' + taskID
            + (xsrf ? ('&xsrf=' + xsrf) : '')
            + '&original_url=' + imageSrc;
        function errorProcess() {
            errorCallback(imageSrc);
        }
        $.ajax({
            url: fetchImageInnerURL,
            dataType: 'json',
            type: 'GET',
            success: function (data, textStatus, request) {
                var status = data.retcode;
                var url = '';
                if (data && data.data && data.data.url) {
                    url = data.data.url;
                }
                if (status === 0 && url.length > 0) {
                    var imagetype = '';
                    if (imageSrc.indexOf('wx_fmt=gif') > 0) {
                        imagetype = 'image/gif';
                    }
                    sucCallback(attachmentId, url, imagetype, 0, 0);
                }
                else if (status === 1 && reqCounter > 0) {
                    // 处理中
                    setTimeout(function () {
                        ImageUploader.tryGetImageInnerURLByTaskID(imageSrc, attachmentId, taskID, reqInterval, reqCounter - 1, sucCallback, errorCallback);
                    }, reqInterval);
                }
                else {
                    // 出错
                    errorProcess();
                }
            },
            error: function (request, textStatus, error) {
                Logger.error('_tryGetImageURL error:' + error.toString());
                if (reqCounter > 0) {
                    setTimeout(function () {
                        ImageUploader.tryGetImageInnerURLByTaskID(imageSrc, attachmentId, taskID, reqInterval, reqCounter - 1, sucCallback, errorCallback);
                    }, reqInterval);
                }
                else {
                    errorProcess();
                }
            },
        });
    };
    ImageUploader.fetchTaskID = function (imageSrc, attachmentId, sucCallback, errorCallback, xsrf) {
        var clientVars = window['clientVars'];
        var fetchURL = 'https://' + LOCATION_HOST + '/v1/image/trans_outer'
            + (xsrf ? "?xsrf=" + xsrf + "&globalPadId=" + clientVars.globalPadId + "&url=" : '?url=') + encodeURIComponent(imageSrc);
        $.ajax({
            url: fetchURL,
            dataType: 'json',
            type: 'GET',
            contentType: 'application/x-www-form-urlencode',
            data: {
                xsrf: xsrf,
                globalPadId: clientVars.globalPadId,
            },
            success: function (data, textStatus, request) {
                Logger.log('_fetchTaskID success:');
                Logger.log(data);
                if (data.retcode === 0) {
                    if (data && data.url && data.url.length > 0) {
                        var imagetype = '';
                        if (imageSrc.indexOf('wx_fmt=gif') > 0) {
                            imagetype = 'image/gif';
                        }
                        sucCallback(attachmentId, data.url, imagetype, data.width, data.height);
                    }
                    else if (data && data.key && data.key.length > 0) {
                        Logger.log('key: ' + data.key);
                        setTimeout(function () {
                            ImageUploader.tryGetImageInnerURLByTaskID(imageSrc, attachmentId, data.key, 3000, 3, sucCallback, errorCallback);
                        }, 3000);
                    }
                    else {
                        errorCallback(imageSrc);
                    }
                }
                else {
                    errorCallback(imageSrc);
                }
            },
            error: function (request, textStatus, error) {
                Logger.error('_fetchTaskID error:' + error.toString());
                errorCallback(imageSrc);
            },
        });
    };
    ImageUploader.uploadImageBase64 = function (id, base64, sucCallback, errCallback, progressCallback, width, height, options) {
        ImageUploader.uploadImageFile(id, base64, sucCallback, errCallback, progressCallback, width, height, true, options);
    };
    ImageUploader.uploadImageFile = function (attachmentId, shrunk, sucCallback, errCallback, progressCallback, width, height, isBase64, options) {
        var _a;
        if (isBase64 === void 0) { isBase64 = false; }
        if (options === void 0) { options = {}; }
        var clientVars = window['clientVars'];
        var uploadUrl = (options === null || options === void 0 ? void 0 : options.uploadUrl) || DEFAULT_UPLOAD_URL;
        var url = uploadUrl + "?globalPadId=" + clientVars.globalPadId;
        (options === null || options === void 0 ? void 0 : options.queryStr) && (url += "&" + options.queryStr);
        var form = new FormData();
        var errorTips = '上传图片失败，请稍后再试。';
        var blob = isBase64 ? ImageUtil.dataURLToBlob(shrunk) : shrunk;
        form.append('file', blob);
        var oReq = new XMLHttpRequest();
        oReq.open('POST', url, true);
        oReq.onload = function () {
            var _a;
            if (oReq.status === 200 && oReq.response) {
                try {
                    var response = JSON.parse(oReq.response);
                    var data = (options === null || options === void 0 ? void 0 : options.responseFormatter) ? options === null || options === void 0 ? void 0 : options.responseFormatter(response) : response;
                    var url_1 = data['url'];
                    if (url_1 && data.retcode === 0) {
                        sucCallback(attachmentId, url_1, blob.type, width, height);
                    }
                    else {
                        switch (data.retcode) {
                            case 90003:
                            case 90011:
                                errorTips = '上传图片失败，请稍后再试。';
                                break;
                            case 90012:
                            case 90013:
                                errorTips = '暂不支持上传SVG格式图片。';
                                break;
                            case 90001:
                            case 10003:
                                errorTips = '暂无权限上传图片，请重新登录后再试。';
                                break;
                            case 90008:
                                errorTips = '上传图片失败，图片损坏或不支持该格式。';
                                break;
                            case 90010:
                                errorTips = '图片体积太大，请压缩后再试。';
                                break;
                        }
                        Logger.error("upload error: " + oReq.response + ", url: " + url_1);
                        errCallback && errCallback(attachmentId, oReq.response, errorTips, {
                            code: data === null || data === void 0 ? void 0 : data.retcode,
                            message: data === null || data === void 0 ? void 0 : data.retmsg,
                        });
                    }
                }
                catch (error) {
                    Logger.error("upload error: " + oReq.response + ", url: " + url + ", code error");
                    errCallback && errCallback(attachmentId, oReq.response, errorTips, {
                        code: exports.CustomizeUploadImageFileErrorCode.CatchError,
                        message: (_a = error) === null || _a === void 0 ? void 0 : _a.message,
                    });
                }
            }
            else {
                Logger.error("upload error: " + oReq.response + ", url: " + url + ", status: " + oReq.status);
                errCallback && errCallback(attachmentId, oReq.response, errorTips, {
                    code: exports.CustomizeUploadImageFileErrorCode.NetWorkStatusError,
                    message: String(oReq.status),
                });
            }
        };
        oReq.upload.onprogress = function (e) {
            var e = e || event;
            if (e.lengthComputable) {
                var percent = Math.floor(e.loaded / e.total * 100);
                if (progressCallback) {
                    progressCallback(attachmentId, percent);
                }
            }
        };
        oReq.onerror = function () {
            Logger.error('upload error response:' + oReq.responseText);
            errCallback && errCallback(attachmentId, 'upload error: ' + oReq.statusText, errorTips, {
                code: exports.CustomizeUploadImageFileErrorCode.OnError,
                message: oReq.responseText,
            });
        };
        oReq.ontimeout = function () {
            Logger.error('upload timeout response:' + oReq.responseText);
            errCallback && errCallback(attachmentId, 'upload timeout', errorTips, {
                code: exports.CustomizeUploadImageFileErrorCode.OnTimeout,
                message: oReq.responseText,
            });
        };
        try {
            oReq.send(form);
        }
        catch (err) {
            Logger.error('upload send XHR error:' + err);
            errCallback && errCallback(attachmentId, 'send XHR error', errorTips, {
                code: exports.CustomizeUploadImageFileErrorCode.CatchError,
                message: (_a = err) === null || _a === void 0 ? void 0 : _a.message,
            });
        }
    };
    ImageUploader.uploadImageCrossDomain = function (imageSrc, attachmentId, sucCallback, errCallback, xsrf, options) {
        var srclink = imageSrc;
        if (imageSrc.indexOf('https') !== 0 && imageSrc.indexOf('http') === 0) {
            srclink = 'https' + imageSrc.substring(4);
        }
        if (imageSrc === '/static/img/insertimagload.png' || imageSrc.indexOf('/static/img/pixel.gif') >= 0) {
            return;
        }
        try {
            if (ImageUtil.isBase64(imageSrc)) {
                var _a = ImageUtil.getImageSize(imageSrc), width = _a.width, height = _a.height;
                ImageUploader.uploadImageFile(attachmentId, imageSrc, sucCallback, errCallback, null, width, height, true, options);
            }
            else {
                ImageUploader.fetchTaskID(imageSrc, attachmentId, sucCallback, errCallback, xsrf);
            }
        }
        catch (e) {
            setTimeout(function () {
                errCallback(attachmentId, imageSrc, 'exception');
            });
        }
    };
    return ImageUploader;
}());

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
/**
 * 平台工具类
 */
var PlatformUtil = /** @class */ (function () {
    function PlatformUtil() {
    }
    // --------------   平台   ------------------
    PlatformUtil.isMobile = function () {
        return /(mobile)/i.test(navigator.userAgent);
    };
    /**
     * 比较版本号大小:
     * v1 > v2 返回正值；v1 = v2 返回0；v1 < v2 返回负值
     * @param v1 版本号v1
     * @param v2 版本号v2
     */
    PlatformUtil.compareVersion = function (v1, v2) {
        var _v1 = v1.split('.');
        var _v2 = v2.split('.');
        var _r = parseInt(_v1[0], 10) - parseInt(_v2[0], 10);
        return _r === 0 && v1 !== v2 ? this.compareVersion(_v1.splice(1).join('.'), _v2.splice(1).join('.')) : _r;
    };
    /**
     * 获取独立App版本
     */
    PlatformUtil.getTencentDocsAppVersion = function () {
        var version = '';
        if (this.isTencentDocsApp()) {
            var match = void 0;
            if (this.isAndroid()) {
                match = navigator.userAgent.match(/TencentDocs\/(\S*).tencentdocs/);
            }
            else if (this.isIOS()) {
                match = navigator.userAgent.match(/TencentDocs\/(\S*)/);
            }
            if (match) {
                version = match[1];
            }
        }
        return version;
    };
    // 判断大于等于独立app版本
    PlatformUtil.checkTencentDocAppVersionSupportFunction = function (functionVersion) {
        var padVersion = this.getTencentDocsAppVersion();
        return this.compareVersion(padVersion, functionVersion) >= 0;
    };
    // 移动端独立App
    PlatformUtil.isTencentDocsApp = function () {
        // 注意：iOS 版携带了 'QQ'
        return /TencentDocs/i.test(navigator.userAgent);
    };
    PlatformUtil.isQQMiniProgram = function () {
        return /QQ\/|TIM/i.test(navigator.userAgent) && this.isMiniProgram();
    };
    PlatformUtil.isAndroid = function () {
        return /(android)/i.test(navigator.userAgent);
    };
    PlatformUtil.isIOS = function () {
        return /(iphone|ipad|ipod)/i.test(navigator.userAgent);
    };
    PlatformUtil.isIPad = function () {
        return /(ipad)/i.test(navigator.userAgent);
    };
    PlatformUtil.isMac = function () {
        return !this.isMobile() && /Mac OS X/i.test(navigator.userAgent);
    };
    // --------------   浏览器   ------------------
    PlatformUtil.isIE = function () {
        return (/msie/i.test(navigator.userAgent) && !this.isOpera()) || /trident/i.test(navigator.userAgent);
    };
    PlatformUtil.isIE9 = function () {
        if (this.isIE()) {
            var version = navigator.appVersion.split(';');
            var trimVersion = version[1].replace(/[ ]/g, '');
            return trimVersion === 'MSIE9.0';
        }
        return false;
    };
    PlatformUtil.isIE10 = function () {
        if (this.isIE()) {
            var version = navigator.appVersion.split(';');
            var trimVersion = version[1].replace(/[ ]/g, '');
            return trimVersion === 'MSIE10.0';
        }
        return false;
    };
    PlatformUtil.isIE11 = function () {
        return !window.ActiveXObject && 'ActiveXObject' in window;
    };
    PlatformUtil.isEdge = function () {
        return /edge/i.test(navigator.userAgent);
    };
    PlatformUtil.isChrome = function () {
        return /chrome/i.test(navigator.userAgent);
    };
    PlatformUtil.isWeMeetApp = function () {
        return /(tencent_wemeet)/i.test(navigator.userAgent) && (this.isIOS() || this.isAndroid());
    };
    PlatformUtil.isFireFox = function () {
        return /firefox/i.test(navigator.userAgent);
    };
    PlatformUtil.isOpera = function () {
        return /opera/i.test(navigator.userAgent);
    };
    PlatformUtil.isSafari = function () {
        return /safari/i.test(navigator.userAgent);
    };
    PlatformUtil.isQBFamily = function () {
        // 包含 MQQBrowser
        return /QQBrowser/i.test(navigator.userAgent);
    };
    PlatformUtil.isMQBFamily = function () {
        // 注意：Android QQ/TIM/WeChat/WeWork 都带了 'MQQBrowser' 和 'TBS'
        return /MQQBrowser/i.test(navigator.userAgent);
    };
    PlatformUtil.isPCQQBrowser = function () {
        return this.isQBFamily() && !this.isMobile() && !/QBCore/i.test(navigator.userAgent); // exclude PC QQ
    };
    PlatformUtil.isMobileQQBrowser = function () {
        return this.isMobile() && this.isMQBFamily() && !/TBS/i.test(navigator.userAgent); // exclude Android QQ/TIM/WeChat/WeWork
    };
    PlatformUtil.isQQBrowser = function () {
        return this.isMobile() ? this.isMobileQQBrowser() : this.isPCQQBrowser();
    };
    PlatformUtil.isWindowStore = function () {
        return /MSAppHost/i.test(navigator.userAgent);
    };
    // --------------   应用   ------------------
    PlatformUtil.isTimQQ = function () {
        // TIM 或 QQ
        // 注意：iOS APP 携带了 'QQ'；Android QQ/TIM/WeChat/WeWork
        return (/(QQ)/i.test(navigator.userAgent) &&
            !this.isTencentDocApp() && // exclude APP
            !this.isWeWork() && // exclude Android WeWork
            !this.isWeChat() && // exclude Android WeChat
            !this.isQQBrowser()); // exclude (M)QQBrowser
    };
    PlatformUtil.isTim = function () {
        return /TIM/i.test(navigator.userAgent);
    };
    PlatformUtil.isQQ = function () {
        return this.isTimQQ() && !this.isTim();
    };
    PlatformUtil.isTencentDocApp = function () {
        // 注意：iOS 版携带了 'QQ'
        return /TencentDocs/i.test(navigator.userAgent);
    };
    PlatformUtil.isWXFamily = function () {
        // 注意：iOS 版企业微信携带了 'MicroMessenger'
        return /MicroMessenger/i.test(navigator.userAgent);
    };
    PlatformUtil.isMiniProgram = function () {
        var wxUrlContainStr = '__wxjs_environment=miniprogram';
        var index = window.location.href.indexOf(wxUrlContainStr);
        return index > -1 || window.__wxjs_environment === 'miniprogram';
    };
    PlatformUtil.isWeWork = function () {
        return /(wxwork)/i.test(navigator.userAgent);
    };
    PlatformUtil.isWeChat = function () {
        return this.isWXFamily() && !this.isWeWork() && !this.isMiniProgram();
    };
    PlatformUtil.isWeiYunApp = function () {
        return /Weiyun/i.test(navigator.userAgent);
    };
    return PlatformUtil;
}());

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
var Fraction = /** @class */ (function (_super) {
    __extends(Fraction, _super);
    function Fraction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Fraction;
}(Number));
// Console debug wrapper that makes code looks a little bit cleaner
var Debug = /** @class */ (function () {
    function Debug() {
    }
    Debug.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (Exif.debug) {
            console.log(args);
        }
    };
    return Debug;
}());
var Exif = /** @class */ (function () {
    function Exif() {
    }
    Exif.addEvent = function (element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        }
        else {
            // Hello, IE!
            if (element.attachEvent) {
                element.attachEvent('on' + event, handler);
            }
        }
    };
    Exif.imageHasData = function (img) {
        return !!img.exifdata;
    };
    Exif.base64ToArrayBuffer = function (base64) {
        base64 = base64.replace(/^data:([^;]+);base64,/gim, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    };
    Exif.objectURLToBlob = function (url, callback) {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = 'blob';
        http.onload = function () {
            if (http.status === 200 || http.status === 0) {
                callback(http.response);
            }
        };
        http.send();
    };
    Exif.getImageData = function (img, callback) {
        function handleBinaryFile(binFile) {
            var data = Exif.findEXIFinJPEG(binFile);
            var iptcdata = Exif.findIPTCinJPEG(binFile);
            img.exifdata = data || {};
            img.iptcdata = iptcdata || {};
            if (callback) {
                callback.call(img);
            }
        }
        if ('src' in img && img.src) {
            if (/^data:/i.test(img.src)) {
                // Data URI
                var arrayBuffer = Exif.base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            }
            else {
                if (/^blob:/i.test(img.src)) {
                    // Object URL
                    var fileReader_1 = new FileReader();
                    fileReader_1.onload = function (e) {
                        handleBinaryFile(e.target.result);
                    };
                    Exif.objectURLToBlob(img.src, function (blob) {
                        fileReader_1.readAsArrayBuffer(blob);
                    });
                }
                else {
                    var http_1 = new XMLHttpRequest();
                    http_1.onload = function () {
                        if (http_1.status === 200 || http_1.status === 0) {
                            handleBinaryFile(http_1.response);
                        }
                        else {
                            throw new Error('Could not load image');
                        }
                    };
                    http_1.open('GET', img.src, true);
                    http_1.responseType = 'arraybuffer';
                    http_1.send(null);
                }
            }
        }
        else {
            if (FileReader && (img instanceof Blob || img instanceof File)) {
                var fileReader = new FileReader();
                fileReader.onload = function (e) {
                    Debug.log('Got file of length ' + e.target.result.byteLength);
                    handleBinaryFile(e.target.result);
                };
                fileReader.readAsArrayBuffer(img);
            }
        }
    };
    Exif.findEXIFinJPEG = function (file) {
        var dataView = new DataView(file);
        Debug.log('Got file of length ' + file.byteLength);
        if (dataView.getUint8(0) !== 0xff || dataView.getUint8(1) !== 0xd8) {
            Debug.log('Not a valid JPEG');
            return false; // not a valid jpeg
        }
        var offset = 2;
        var length = file.byteLength;
        var marker;
        while (offset < length) {
            if (dataView.getUint8(offset) !== 0xff) {
                Debug.log('Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            Debug.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker === 225) {
                Debug.log('Found 0xFFE1 marker');
                return Exif.readEXIFData(dataView, offset + 4); // , dataView.getUint16(offset + 2) - 2);
                // offset += 2 + file.getShortAt(offset+2, true);
            }
            else {
                offset += 2 + dataView.getUint16(offset + 2);
            }
        }
    };
    Exif.findIPTCinJPEG = function (file) {
        var dataView = new DataView(file);
        Debug.log('Got file of length ' + file.byteLength);
        if (dataView.getUint8(0) !== 0xff || dataView.getUint8(1) !== 0xd8) {
            Debug.log('Not a valid JPEG');
            return false; // not a valid jpeg
        }
        var offset = 2;
        var length = file.byteLength;
        var isFieldSegmentStart = function (_dataView, _offset) {
            return (_dataView.getUint8(_offset) === 0x38 &&
                _dataView.getUint8(_offset + 1) === 0x42 &&
                _dataView.getUint8(_offset + 2) === 0x49 &&
                _dataView.getUint8(_offset + 3) === 0x4d &&
                _dataView.getUint8(_offset + 4) === 0x04 &&
                _dataView.getUint8(_offset + 5) === 0x04);
        };
        while (offset < length) {
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) {
                    nameHeaderLength += 1;
                }
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return Exif.readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    };
    Exif.readIPTCData = function (file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType;
        var segmentStartPos = startOffset;
        while (segmentStartPos < startOffset + sectionLength) {
            if (dataView.getUint8(segmentStartPos) === 0x1c && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in Exif.IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    fieldName = Exif.IptcFieldMap[segmentType];
                    fieldValue = Exif.getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }
            }
            segmentStartPos++;
        }
        return data;
    };
    Exif.readTags = function (file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd);
        var tags = {};
        var entryOffset;
        var tag;
        for (var i = 0; i < entries; i++) {
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag) {
                Debug.log('Unknown tag: ' + file.getUint16(entryOffset, !bigEnd));
            }
            tags[tag] = Exif.readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    };
    Exif.readTagValue = function (file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd);
        var numValues = file.getUint32(entryOffset + 4, !bigEnd);
        var valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart;
        var offset;
        var vals, val, n;
        var numerator;
        var denominator;
        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues === 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }
            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : entryOffset + 8;
                return Exif.getStringFromDB(file, offset, numValues - 1);
            case 3: // short, 16 bit int
                if (numValues === 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;
                }
            case 4: // long, 32 bit int
                if (numValues === 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 5: // rational = two long values, first is numerator, second is denominator
                if (numValues === 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Fraction(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = new Fraction(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }
            case 9: // slong, 32 bit signed int
                if (numValues === 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues === 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
                }
            default:
                break;
        }
    };
    Exif.getStringFromDB = function (buffer, start, length) {
        var outstr = '';
        for (var n = start; n < start + length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    };
    Exif.readEXIFData = function (file, start) {
        if (Exif.getStringFromDB(file, start, 4) !== 'Exif') {
            Debug.log('Not valid EXIF data! ' + Exif.getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) === 0x4949) {
            bigEnd = false;
        }
        else {
            if (file.getUint16(tiffOffset) === 0x4d4d) {
                bigEnd = true;
            }
            else {
                Debug.log('Not valid TIFF data! (no 0x4949 or 0x4D4D)');
                return false;
            }
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002a) {
            Debug.log('Not valid TIFF data! (no 0x002A)');
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            Debug.log('Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = Exif.readTags(file, tiffOffset, tiffOffset + firstIFDOffset, Exif.TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = Exif.readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, Exif.Tags, bigEnd);
            for (tag in exifData) {
                if ({}.hasOwnProperty.call(exifData, tag)) {
                    switch (tag) {
                        case 'LightSource':
                        case 'Flash':
                        case 'MeteringMode':
                        case 'ExposureProgram':
                        case 'SensingMethod':
                        case 'SceneCaptureType':
                        case 'SceneType':
                        case 'CustomRendered':
                        case 'WhiteBalance':
                        case 'GainControl':
                        case 'Contrast':
                        case 'Saturation':
                        case 'Sharpness':
                        case 'SubjectDistanceRange':
                        case 'FileSource':
                            exifData[tag] = Exif.StringValues[tag][exifData[tag]];
                            break;
                        case 'ExifVersion':
                        case 'FlashpixVersion':
                            exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                            break;
                        case 'ComponentsConfiguration':
                            var compopents = 'Components';
                            exifData[tag] =
                                Exif.StringValues[compopents][exifData[tag][0]] +
                                    Exif.StringValues[compopents][exifData[tag][1]] +
                                    Exif.StringValues[compopents][exifData[tag][2]] +
                                    Exif.StringValues[compopents][exifData[tag][3]];
                            break;
                        default:
                            break;
                    }
                    tags[tag] = exifData[tag];
                }
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = Exif.readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, Exif.GPSTags, bigEnd);
            for (tag in gpsData) {
                if ({}.hasOwnProperty.call(gpsData, tag)) {
                    switch (tag) {
                        case 'GPSVersionID':
                            gpsData[tag] = gpsData[tag][0] + '.' + gpsData[tag][1] + '.' + gpsData[tag][2] + '.' + gpsData[tag][3];
                            break;
                        default:
                            break;
                    }
                    tags[tag] = gpsData[tag];
                }
            }
        }
        return tags;
    };
    //   get rid of this silly issue
    Exif.checkImageType = function (img) {
        return img instanceof Image || img instanceof HTMLImageElement;
    };
    Exif.getData = function (img, callback) {
        if (this.checkImageType(img) && !img.complete) {
            return false;
        }
        if (!Exif.imageHasData(img)) {
            Exif.getImageData(img, callback);
        }
        else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    };
    Exif.getTag = function (img, tag) {
        if (!Exif.imageHasData(img)) {
            return;
        }
        return img.exifdata[tag];
    };
    Exif.getAllTags = function (img) {
        if (!Exif.imageHasData(img)) {
            return {};
        }
        var a, data = img.exifdata, tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    };
    Exif.pretty = function (img) {
        if (!Exif.imageHasData(img)) {
            return '';
        }
        var a, data = img.exifdata, strPretty = '';
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] === 'object') {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    }
                    else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                }
                else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    };
    Exif.readFromBinaryFile = function (file) {
        return Exif.findEXIFinJPEG(file);
    };
    Exif.debug = false;
    Exif.IptcFieldMap = {
        0x78: 'caption',
        0x6e: 'credit',
        0x19: 'keywords',
        0x37: 'dateCreated',
        0x50: 'byline',
        0x55: 'bylineTitle',
        0x7a: 'captionWriter',
        0x69: 'headline',
        0x74: 'copyright',
        0x0f: 'category',
    };
    Exif.Tags = {
        // version tags
        0x9000: 'ExifVersion',
        0xa000: 'FlashpixVersion',
        // colorspace tags
        0xa001: 'ColorSpace',
        // image configuration
        0xa002: 'PixelXDimension',
        0xa003: 'PixelYDimension',
        0x9101: 'ComponentsConfiguration',
        0x9102: 'CompressedBitsPerPixel',
        // user information
        0x927c: 'MakerNote',
        0x9286: 'UserComment',
        // related file
        0xa004: 'RelatedSoundFile',
        // date and time
        0x9003: 'DateTimeOriginal',
        0x9004: 'DateTimeDigitized',
        0x9290: 'SubsecTime',
        0x9291: 'SubsecTimeOriginal',
        0x9292: 'SubsecTimeDigitized',
        // picture-taking conditions
        0x829a: 'ExposureTime',
        0x829d: 'FNumber',
        0x8822: 'ExposureProgram',
        0x8824: 'SpectralSensitivity',
        0x8827: 'ISOSpeedRatings',
        0x8828: 'OECF',
        0x9201: 'ShutterSpeedValue',
        0x9202: 'ApertureValue',
        0x9203: 'BrightnessValue',
        0x9204: 'ExposureBias',
        0x9205: 'MaxApertureValue',
        0x9206: 'SubjectDistance',
        0x9207: 'MeteringMode',
        0x9208: 'LightSource',
        0x9209: 'Flash',
        0x9214: 'SubjectArea',
        0x920a: 'FocalLength',
        0xa20b: 'FlashEnergy',
        0xa20c: 'SpatialFrequencyResponse',
        0xa20e: 'FocalPlaneXResolution',
        0xa20f: 'FocalPlaneYResolution',
        0xa210: 'FocalPlaneResolutionUnit',
        0xa214: 'SubjectLocation',
        0xa215: 'ExposureIndex',
        0xa217: 'SensingMethod',
        0xa300: 'FileSource',
        0xa301: 'SceneType',
        0xa302: 'CFAPattern',
        0xa401: 'CustomRendered',
        0xa402: 'ExposureMode',
        0xa403: 'WhiteBalance',
        0xa404: 'DigitalZoomRation',
        0xa405: 'FocalLengthIn35mmFilm',
        0xa406: 'SceneCaptureType',
        0xa407: 'GainControl',
        0xa408: 'Contrast',
        0xa409: 'Saturation',
        0xa40a: 'Sharpness',
        0xa40b: 'DeviceSettingDescription',
        0xa40c: 'SubjectDistanceRange',
        // other tags
        0xa005: 'InteroperabilityIFDPointer',
        0xa420: 'ImageUniqueID',
    };
    Exif.TiffTags = {
        0x0100: 'ImageWidth',
        0x0101: 'ImageHeight',
        0x8769: 'ExifIFDPointer',
        0x8825: 'GPSInfoIFDPointer',
        0xa005: 'InteroperabilityIFDPointer',
        0x0102: 'BitsPerSample',
        0x0103: 'Compression',
        0x0106: 'PhotometricInterpretation',
        0x0112: 'Orientation',
        0x0115: 'SamplesPerPixel',
        0x011c: 'PlanarConfiguration',
        0x0212: 'YCbCrSubSampling',
        0x0213: 'YCbCrPositioning',
        0x011a: 'XResolution',
        0x011b: 'YResolution',
        0x0128: 'ResolutionUnit',
        0x0111: 'StripOffsets',
        0x0116: 'RowsPerStrip',
        0x0117: 'StripByteCounts',
        0x0201: 'JPEGInterchangeFormat',
        0x0202: 'JPEGInterchangeFormatLength',
        0x012d: 'TransferFunction',
        0x013e: 'WhitePoint',
        0x013f: 'PrimaryChromaticities',
        0x0211: 'YCbCrCoefficients',
        0x0214: 'ReferenceBlackWhite',
        0x0132: 'DateTime',
        0x010e: 'ImageDescription',
        0x010f: 'Make',
        0x0110: 'Model',
        0x0131: 'Software',
        0x013b: 'Artist',
        0x8298: 'Copyright',
    };
    Exif.GPSTags = {
        0x0000: 'GPSVersionID',
        0x0001: 'GPSLatitudeRef',
        0x0002: 'GPSLatitude',
        0x0003: 'GPSLongitudeRef',
        0x0004: 'GPSLongitude',
        0x0005: 'GPSAltitudeRef',
        0x0006: 'GPSAltitude',
        0x0007: 'GPSTimeStamp',
        0x0008: 'GPSSatellites',
        0x0009: 'GPSStatus',
        0x000a: 'GPSMeasureMode',
        0x000b: 'GPSDOP',
        0x000c: 'GPSSpeedRef',
        0x000d: 'GPSSpeed',
        0x000e: 'GPSTrackRef',
        0x000f: 'GPSTrack',
        0x0010: 'GPSImgDirectionRef',
        0x0011: 'GPSImgDirection',
        0x0012: 'GPSMapDatum',
        0x0013: 'GPSDestLatitudeRef',
        0x0014: 'GPSDestLatitude',
        0x0015: 'GPSDestLongitudeRef',
        0x0016: 'GPSDestLongitude',
        0x0017: 'GPSDestBearingRef',
        0x0018: 'GPSDestBearing',
        0x0019: 'GPSDestDistanceRef',
        0x001a: 'GPSDestDistance',
        0x001b: 'GPSProcessingMethod',
        0x001c: 'GPSAreaInformation',
        0x001d: 'GPSDateStamp',
        0x001e: 'GPSDifferential',
    };
    Exif.StringValues = {
        ExposureProgram: {
            0: 'Not defined',
            1: 'Manual',
            2: 'Normal program',
            3: 'Aperture priority',
            4: 'Shutter priority',
            5: 'Creative program',
            6: 'Action program',
            7: 'Portrait mode',
            8: 'Landscape mode',
        },
        MeteringMode: {
            0: 'Unknown',
            1: 'Average',
            2: 'CenterWeightedAverage',
            3: 'Spot',
            4: 'MultiSpot',
            5: 'Pattern',
            6: 'Partial',
            255: 'Other',
        },
        LightSource: {
            0: 'Unknown',
            1: 'Daylight',
            2: 'Fluorescent',
            3: 'Tungsten (incandescent light)',
            4: 'Flash',
            9: 'Fine weather',
            10: 'Cloudy weather',
            11: 'Shade',
            12: 'Daylight fluorescent (D 5700 - 7100K)',
            13: 'Day white fluorescent (N 4600 - 5400K)',
            14: 'Cool white fluorescent (W 3900 - 4500K)',
            15: 'White fluorescent (WW 3200 - 3700K)',
            17: 'Standard light A',
            18: 'Standard light B',
            19: 'Standard light C',
            20: 'D55',
            21: 'D65',
            22: 'D75',
            23: 'D50',
            24: 'ISO studio tungsten',
            255: 'Other',
        },
        Flash: {
            0x0000: 'Flash did not fire',
            0x0001: 'Flash fired',
            0x0005: 'Strobe return light not detected',
            0x0007: 'Strobe return light detected',
            0x0009: 'Flash fired, compulsory flash mode',
            0x000d: 'Flash fired, compulsory flash mode, return light not detected',
            0x000f: 'Flash fired, compulsory flash mode, return light detected',
            0x0010: 'Flash did not fire, compulsory flash mode',
            0x0018: 'Flash did not fire, auto mode',
            0x0019: 'Flash fired, auto mode',
            0x001d: 'Flash fired, auto mode, return light not detected',
            0x001f: 'Flash fired, auto mode, return light detected',
            0x0020: 'No flash function',
            0x0041: 'Flash fired, red-eye reduction mode',
            0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
            0x0047: 'Flash fired, red-eye reduction mode, return light detected',
            0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
            0x004d: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
            0x004f: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
            0x0059: 'Flash fired, auto mode, red-eye reduction mode',
            0x005d: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
            0x005f: 'Flash fired, auto mode, return light detected, red-eye reduction mode',
        },
        SensingMethod: {
            1: 'Not defined',
            2: 'One-chip color area sensor',
            3: 'Two-chip color area sensor',
            4: 'Three-chip color area sensor',
            5: 'Color sequential area sensor',
            7: 'Trilinear sensor',
            8: 'Color sequential linear sensor',
        },
        SceneCaptureType: {
            0: 'Standard',
            1: 'Landscape',
            2: 'Portrait',
            3: 'Night scene',
        },
        SceneType: {
            1: 'Directly photographed',
        },
        CustomRendered: {
            0: 'Normal process',
            1: 'Custom process',
        },
        WhiteBalance: {
            0: 'Auto white balance',
            1: 'Manual white balance',
        },
        GainControl: {
            0: 'None',
            1: 'Low gain up',
            2: 'High gain up',
            3: 'Low gain down',
            4: 'High gain down',
        },
        Contrast: {
            0: 'Normal',
            1: 'Soft',
            2: 'Hard',
        },
        Saturation: {
            0: 'Normal',
            1: 'Low saturation',
            2: 'High saturation',
        },
        Sharpness: {
            0: 'Normal',
            1: 'Soft',
            2: 'Hard',
        },
        SubjectDistanceRange: {
            0: 'Unknown',
            1: 'Macro',
            2: 'Close view',
            3: 'Distant view',
        },
        FileSource: {
            3: 'DSC',
        },
        Components: {
            0: '',
            1: 'Y',
            2: 'Cb',
            3: 'Cr',
            4: 'R',
            5: 'G',
            6: 'B',
        },
    };
    return Exif;
}());

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
var CompressorError;
(function (CompressorError) {
    CompressorError["UNKNOW"] = "0";
    CompressorError["NOT_IMAGE"] = "1";
    CompressorError["SIZE_INVALID_FOR_IE"] = "2";
    CompressorError["SIZE_INVALID_FOR_OPERATION"] = "3";
})(CompressorError || (CompressorError = {}));
var Compressor = /** @class */ (function () {
    function Compressor() {
    }
    Compressor.maybeShrinkImage = function (file, option, callback) {
        Logger.info('image compressor: maybeShrinkImage start');
        if (file.type.indexOf('image') === -1) {
            // "不支持该类型文件上传"
            callback && callback(null, 0, 0, CompressorError.NOT_IMAGE);
            return;
        }
        if (file.type.indexOf('image/tif') >= 0 || file.type.indexOf('image/tiff') >= 0) {
            callback(file, 0, 0);
            return;
        }
        if (PlatformUtil.isIE() && file.size > option.maxSizeForIE) {
            Logger.info('image compressor: more than 10M');
            // toast "请选择10M以内的图片插入"
            callback && callback(null, 0, 0, CompressorError.SIZE_INVALID_FOR_IE);
            return;
        }
        else if (file.size > option.maxSize) {
            Logger.info('image compressor: more than 20M');
            // "请选择20M以内的图片插入"
            callback && callback(null, 0, 0, CompressorError.SIZE_INVALID_FOR_OPERATION);
            return;
        }
        // 这里提前取出来 orientation
        var orientation;
        Exif.getData(file, function () {
            orientation = Exif.getTag(file, 'Orientation');
            Logger.info("image compressor: orientation: " + orientation);
        });
        var reader = new FileReader();
        // 读取文件的内容
        reader.onloadend = function () {
            // const { width, height } = ImageUtil.getImageSize(reader.result);
            // // 不进行压缩的场景，且base64符合规则时，直接返回对应的图片
            // if (width > 0 && height > 0 && file.size < option.minSize && !PlatformUtil.isIOS) {
            //     Compressor.afterCompressor(file, width, height, orientation, option, callback);
            //     return;
            // }
            var image = new Image();
            // different iamge type will use diff process method
            image.onload = function () {
                // 如果是 gif 图则直接返回，其他类型图片，小于2M且非IOS平台的的直接返回
                if (file.type.indexOf('image/gif') === 0 || (file.size < option.minSize && !PlatformUtil.isIOS())) {
                    Logger.info('image compressor: not compress');
                    Compressor.afterCompressor(file, image.width, image.height, orientation, option, callback);
                }
                else {
                    var obj = void 0;
                    if (file.type.indexOf('image/bmp') >= 0) {
                        obj = Compressor.domProcess(file, image); // bmp process
                    }
                    else {
                        obj = Compressor.canvasProcess(file, option, image); // png, jpg etc.
                    }
                    // obj 不为空的情况下，说明正常执行了压缩策略，需要执行压缩后策略。 obj 为空说明压缩时已经执行了 callback，就不要多余操作了
                    // TODO 这里需要处理好返回值以及各函数间的调用关系，目前较混乱
                    if (obj) {
                        Compressor.afterCompressor(obj.blob, obj.imageWidth, obj.imageHeight, orientation, image, callback);
                    }
                    else {
                        // obj为空也需要回调
                        Compressor.afterCompressor(null, 0, 0, 0, image, callback);
                    }
                }
            };
            image.onerror = function () {
                callback && callback(null, 0, 0, CompressorError.UNKNOW);
                return;
            };
            image.src = reader.result;
        };
        reader.onerror = function () {
            callback && callback(null, 0, 0, CompressorError.UNKNOW);
            return;
        };
        reader.readAsDataURL(file);
    };
    // 旋转手机竖拍的图片，并回调 ImageBlob
    // 二进制 => base64 => 获取图片实体 => canvas 旋转 => 导出二进制
    Compressor.rotateImage = function (file, option, callback, orientation) {
        Logger.log('image compresss: rotateImage');
        // 如果图片特别大速度会有点慢
        // 设定图片最大宽度，超过进行压缩
        var maxWidth = option.maxRotateWidth;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            var imgBase64 = this.result || e.target.result;
            var image = new Image();
            image.onload = function () {
                var rate = image.width / maxWidth;
                var isOverWidth =  image.width > maxWidth;
                var width = isOverWidth ? maxWidth : image.width;
                var height = isOverWidth ? image.height / rate : image.height;
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                if (orientation !== '' && orientation !== 1 && orientation !== undefined) {
                    Logger.info("image compressor: orientation rotate: " + orientation);
                    switch (orientation) {
                        case 6: // 需要顺时针90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            context.rotate((90 * Math.PI) / 180);
                            context.drawImage(image, 0, -height, width, height);
                            height = canvas.height;
                            width = canvas.width;
                            break;
                        case 8: // 需要逆时针90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            context.rotate((-90 * Math.PI) / 180);
                            context.drawImage(image, -width, 0, width, height);
                            height = canvas.height;
                            width = canvas.width;
                            break;
                        case 3: // 需要180度旋转
                            canvas.width = width;
                            canvas.height = height;
                            context.rotate((180 * Math.PI) / 180);
                            context.drawImage(image, -width, -height, width, height);
                            height = canvas.height;
                            width = canvas.width;
                            break;
                        default:
                            callback(file, width, height);
                            return;
                    }
                }
                else {
                    callback(file, image.width, image.height);
                    return;
                }
                try {
                    canvas.toBlob(function (blob) {
                        callback(blob, width, height);
                    });
                }
                catch (e) {
                    Logger.info('image compressor: toBlob error');
                    // 某些低端版本的 iOS 不支持 toBlob 方法
                    try {
                        var filetype = (file && file.type) || 'image/jpeg';
                        var binStr = atob(canvas.toDataURL(filetype, 1).split(',')[1]);
                        var len = binStr.length;
                        var arr = new Uint8Array(len);
                        for (var i = 0; i < len; i++) {
                            arr[i] = binStr.charCodeAt(i);
                        }
                        callback(new Blob([arr], { type: filetype }), width, height);
                    }
                    catch (ee) {
                        Logger.info('image compressor: atob error');
                        callback(file, width, height);
                    }
                }
            };
            image.src = imgBase64;
        };
    };
    // process image on canvas
    Compressor.canvasProcess = function (file, option, image) {
        Logger.log('image compresss: canvasProcess');
        var maxWidth = option.maxWidth, maxHeight = option.maxHeight, imageWidth = image.width, imageHeight = image.height, minWidth = option.minWidth, minHeight = option.minHeight;
        if (imageWidth > imageHeight * 3) {
            // 长边大于短边3倍的长图压缩策略
            if (imageHeight < minHeight) {
                // 不压缩
                return { imageWidth: imageWidth, imageHeight: imageHeight, blob: file };
            }
            else {
                imageWidth *= minHeight / imageHeight;
                imageHeight = minHeight;
            }
        }
        else if (imageHeight > imageWidth * 3) {
            // 长边大于短边3倍的长图压缩策略
            if (imageWidth < minWidth) {
                // 不压缩
                return { imageWidth: imageWidth, imageHeight: imageHeight, blob: file };
            }
            else {
                imageHeight *= minWidth / imageWidth;
                imageWidth = minWidth;
            }
        }
        else if (imageWidth > imageHeight) {
            // 普通图片压缩策略
            if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
            }
        }
        else {
            // 普通图片压缩策略
            if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
            }
        }
        var canvas = document.createElement('canvas');
        canvas.width = imageWidth;
        canvas.height = imageHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, imageWidth, imageHeight);
        var dataUrl = canvas.toDataURL(file.type, option.quality);
        var blob = ImageUtil.dataURLToBlob(dataUrl);
        // 压缩超过10倍视为严重失真或压缩失败，应返回原图（不论任何格式，不然容易出现空白图片）
        if (file.size > 10 * blob.size) {
            return { imageWidth: imageWidth, imageHeight: imageHeight, blob: file };
        }
        // 压缩后变大且非ios的情况下，返回原file。IOS必须返回压缩后的图片，因为压缩过程涉及图片旋转操作
        if (file && file.size > 0 && blob.size > file.size && !PlatformUtil.isIOS()) {
            return { imageWidth: imageWidth, imageHeight: imageHeight, blob: file };
        }
        return { imageWidth: imageWidth, imageHeight: imageHeight, blob: blob };
    };
    // process image on dom
    Compressor.domProcess = function (file, image) {
        var blob = file;
        var imageWidth = image.width;
        var imageHeight = image.height;
        var imageInDom = document.createElement('img');
        imageInDom.width = imageWidth;
        imageInDom.height = imageHeight;
        return { imageWidth: imageWidth, imageHeight: imageHeight, blob: blob };
    };
    Compressor.afterCompressor = function (blob, width, height, orientation, option, callback) {
        if (option.checkOrientation) {
            Logger.info('image compressor: afterCompressor start');
            this.rotateImage(blob, option, callback, orientation);
        }
        else {
            Logger.info("image compressor: not afterCompressor: " + option);
            callback(blob, width, height);
        }
    };
    return Compressor;
}());

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/crop/index.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/crop
 * Created Date: Tuesday, April 9th 2020, 4:41:34 pm
 * Author: dickyduan
 *
 * Copyright (c) 2020 Your Company
 */
var CropError;
(function (CropError) {
    CropError["UNKNOW"] = "0";
    CropError["NOT_IMAGE"] = "1";
    CropError["SIZE_INVALID_FOR_IE"] = "2";
    CropError["SIZE_INVALID_FOR_OPERATION"] = "3";
})(CropError || (CropError = {}));
var Crop = /** @class */ (function () {
    function Crop() {
    }
    Crop.dataURLToBlob = function (dataURI) {
        // convert base64 to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        }
        else {
            byteString = unescape(dataURI.split(',')[1]);
        }
        // separate out the mime component
        var mimeString = dataURI
            .split(',')[0]
            .split(':')[1]
            .split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };
    Crop.maybeCropImage = function (file, option, callback) {
        var that = this;
        function afterCrop(blob) {
            callback(blob);
        }
        if (file.type.indexOf('image') === -1) {
            // "不支持该类型文件上传"
            callback && callback(null, 0, 0, CropError.NOT_IMAGE);
            return;
        }
        if (file.type.indexOf('image/tif') >= 0 || file.type.indexOf('image/tiff') >= 0 || file.type.indexOf('image/bmp') >= 0) {
            callback(file, 0, 0);
            return;
        }
        if (PlatformUtil.isIE() && file.size > option.maxSizeForIE) {
            // toast "请选择10M以内的图片插入"
            callback && callback(null, 0, 0, CropError.SIZE_INVALID_FOR_IE);
            return;
        }
        else if (file.size > option.maxSize) {
            // "请选择20M以内的图片插入"
            callback && callback(null, 0, 0, CropError.SIZE_INVALID_FOR_OPERATION);
            return;
        }
        var reader = new FileReader();
        reader.onloadend = function () {
            var image = new Image();
            image.onload = function () {
                if (file.type.indexOf('image/gif') === 0) {
                    afterCrop(file);
                }
                else {
                    var canvas = document.createElement('canvas');
                    canvas.width = option.clipWidth;
                    canvas.height = option.clipHeight;
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(image, -1 * option.clipLeft, -1 * option.clipTop);
                    var dataUrl = canvas.toDataURL(file.type, option.quality);
                    var blob = that.dataURLToBlob(dataUrl);
                    // all done
                    afterCrop(blob);
                }
            };
            image.src = reader.result;
        };
        reader.readAsDataURL(file);
    };
    return Crop;
}());

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/crop/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/crop
 * Created Date: Tuesday, April 9th 2020, 4:41:34 pm
 * Author: dickyduan
 *
 * Copyright (c) 2020 Your Company
 */
var CropImageOption = /** @class */ (function () {
    function CropImageOption() {
        /**
         * 普通浏览器最大上传图片大小限制
         */
        this.maxSize = 20 * 1024 * 1024;
        /**
         * ie浏览器最大上传图片大小限制
         */
        this.maxSizeForIE = 10 * 1024 * 1024;
        /**
         * 裁剪范围，开始剪切图片的 x 坐标位置
         */
        this.clipLeft = 0;
        /**
         * 裁剪范围，开始剪切图片的 y 坐标位置
         */
        this.clipTop = 0;
        /**
         * 裁剪范围，被剪切图像的宽度（就是裁剪之前的图片宽度，这里的宽度若小于图片的原宽。则图片多余部分被剪掉；若大于，则会以空白填充）
         */
        this.clipWidth = 0;
        /**
         * 裁剪范围，被剪切图像的宽度（就是裁剪之前的图片高度，这里的宽度若小于图片的高宽。则图片多余部分被剪掉；若大于，则会以空白填充）
         */
        this.clipHeight = 0;
        /**
        * The quality of the output image.
        * It must be a number between `0` and `1`,
        * and only available for `image/jpeg` and `image/webp` images.
        * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
        * @type {number}
        */
        this.quality = 1;
    }
    return CropImageOption;
}());

/*
 * Filename: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor/option.ts
 * Path: /Users/sherryfancy/code/tencentDoc/ImageComponents/lib/upload/compressor
 * Created Date: Tuesday, April 9th 2019, 4:41:34 pm
 * Author: zealotchen
 *
 * Copyright (c) 2019 Your Company
 */
var ImageOption = /** @class */ (function () {
    function ImageOption() {
        /**
         * Indicates if read the image's Exif Orientation information,
         * and then rotate or flip the image automatically.
         * @type {boolean}
         */
        this.checkOrientation = true;
        /**
         * The max width of the output image.
         * @type {number}
         */
        this.maxWidth = 4096 * 3;
        /**
         * The max height of the output image.
         * @type {number}
         */
        this.maxHeight = 4096 * 3;
        /**
         * 手机图片上传,如果需要旋转后再上传，所以这里也需要增加一个最大图片的宽度来放缩处理
         * @type {number}
         */
        this.maxRotateWidth = 1280;
        /**
         * The min width of the output image.
         * @type {number}
         */
        this.minWidth = 4096;
        /**
         * The min height of the output image.
         * @type {number}
         */
        this.minHeight = 4096;
        /**
         * The quality of the output image.
         * It must be a number between `0` and `1`,
         * and only available for `image/jpeg` and `image/webp` images.
         * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
         * @type {number}
         */
        this.quality = 0.8;
        /**
         * The mime type of the output image.
         * By default, the original mime type of the source image file will be used.
         * @type {string}
         */
        this.mimeType = 'auto';
        /**
         * 普通浏览器最大上传图片大小限制
         */
        this.maxSize = 20 * 1024 * 1024;
        /**
         * ie浏览器最大上传图片大小限制
         */
        this.maxSizeForIE = 10 * 1024 * 1024;
        /**
         * 小于这个大小，则不用压缩，直接上传
         */
        this.minSize = 2000000;
    }
    return ImageOption;
}());

// 拍照特殊处理机型的 ua 列表
//不可能做到所有机型都case by case解决，这里需要研究下，但避免错误改动造成更大影响，这里收一下范围 @yongbinliao
var spUAList = ['HUAWEIOCE-AN10', 'HUAWEITAS-AL00', 'NAM-AL00', 'JEF-AN00'];
/**
 * 尝试获得拍照权限，并获取视频流
 * 参见 melo 项目 melo-features/src/features/common/ocr/ocr_capturer.tsx 以及 SC 组件 MobileCamera
 */
var getCameraStream = function (props) {
    if (props === void 0) { props = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _i, _a, constraint, devices, videoDevice, result, e_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _i = 0, _a = [
                        { video: { width: { exact: 1920 }, height: { exact: 1080 } } },
                        { video: { width: { exact: 1280 }, height: { exact: 720 } } },
                        { video: {} },
                    ];
                    _e.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 7];
                    constraint = _a[_i];
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
                case 3:
                    devices = _e.sent();
                    videoDevice = devices.filter(function (device) { return device.kind === 'videoinput'; }).pop();
                    return [4 /*yield*/, Promise.race([
                            navigator.mediaDevices.getUserMedia({
                                video: __assign({ deviceId: videoDevice.deviceId, facingMode: { exact: 'environment' } }, constraint.video),
                            }),
                            new Promise(function (_, reject) { return setTimeout(function () { return reject(Error('getUserMedia timeout')); }, 3000); }),
                        ])];
                case 4:
                    result = _e.sent();
                    return [2 /*return*/, result];
                case 5:
                    e_1 = _e.sent();
                    (_b = props.onError) === null || _b === void 0 ? void 0 : _b.call(props, {
                        message: '获取单个视频流出错',
                        type: 'CameraStreamError'
                    });
                    Logger.error(e_1 === null || e_1 === void 0 ? void 0 : e_1.message);
                    tencentDocReport.tdw({
                        opername: 'image_selector',
                        module: 'get_camera_stream',
                        action: 'error',
                        ver5: e_1 === null || e_1 === void 0 ? void 0 : e_1.message,
                        ver6: e_1 === null || e_1 === void 0 ? void 0 : e_1.code,
                        ver7: e_1 === null || e_1 === void 0 ? void 0 : e_1.name,
                    });
                    if ((e_1 === null || e_1 === void 0 ? void 0 : e_1.name) === 'NotAllowedError') {
                        (_c = props.onError) === null || _c === void 0 ? void 0 : _c.call(props, {
                            message: '暂无开启相机权限',
                            type: 'NotAllowedError'
                        });
                        throw Error('getCamera NotAllowedError');
                    }
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7:
                    (_d = props.onError) === null || _d === void 0 ? void 0 : _d.call(props, {
                        message: '暂时无法打开相机,可联系运营进行反馈',
                        type: 'ConstraintNullError'
                    });
                    throw Error('constraint is null');
            }
        });
    });
};
/**
 * 关闭视频流
 * @param stream
 */
var stopCameraStream = function (stream) {
    stream.getTracks().forEach(function (track) { return track.stop(); });
};
/**
 * base64 转 Blob 对象
 * @param dataURL base64数据
 */
function dataURLToBlob(dataURL) {
    // 截取dataUrl中的base64内容
    var parts = dataURL.split(';base64,');
    var _a = parts[0].split(':'), contentType = _a[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);
    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
}
/**
 * 获取拍照选图时 H5 标签信息串，此处用于兼容机型逻辑
 */
function getH5CaptureAttr(capture) {
    // 非拍照，非安卓情景直接使用 'image/*'
    if (!capture || !PlatformUtil.isAndroid()) {
        return 'image/*';
    }
    // 如果是华为机型（如 mate40），也返回 'image/*'，此处只能逐一解决兼容
    // 手动实验后特殊机型的'image/camera'在腾讯文档app中可以使用，故手动排除一下
    var isSpecialMobile = spUAList.some(function (ua) { return navigator.userAgent.search(ua) !== -1; }) && !PlatformUtil.isTencentDocsApp();
    return isSpecialMobile ? 'image/*' : 'image/camera';
}

__$styleInject("@keyframes slide-in-portrait {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n@keyframes slide-in-landscape {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n.mobile-camera {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100000;\n  background-color: black;\n  overflow: hidden;\n  padding-top: constant(safe-area-inset-top);\n  padding-top: env(safe-area-inset-top);\n  padding-left: constant(safe-area-inset-left);\n  padding-left: env(safe-area-inset-left);\n  padding-right: constant(safe-area-inset-right);\n  padding-right: env(safe-area-inset-right);\n  padding-bottom: constant(safe-area-inset-bottom);\n  padding-bottom: env(safe-area-inset-bottom);\n  animation: slide-in-portrait ease forwards 0.3s;\n  user-select: none;\n  touch-action: none;\n}\n.mobile-camera-preview,\n.mobile-camera-viewfinder {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n.mobile-camera-slide-out {\n  animation: slide-in-portrait reverse ease forwards 0.2s;\n}\n.mobile-camera-viewfinder-video-container,\n.mobile-camera-preview-image-container {\n  flex: 1 1 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n}\n.mobile-camera-stricker-layer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 133vw;\n  margin: auto;\n}\n.mobile-camera-viewfinder-video {\n  width: 100%;\n  height: 133vw;\n  object-fit: cover;\n}\n.mobile-camera-preview-image {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n.mobile-camera-action-container {\n  width: 100%;\n  height: 120px;\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.mobile-camera-action-left,\n.mobile-camera-action-right {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 20px;\n  line-height: 20px;\n  color: #fff;\n  font-size: 17px;\n  background: none;\n  border: none;\n  outline: none;\n  white-space: nowrap;\n}\n.mobile-camera-action-left {\n  left: 30px;\n}\n.mobile-camera-action-right {\n  right: 30px;\n  color: #fc1;\n}\n.mobile-camera-action-capture {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 2px solid black;\n  box-shadow: 0 0 0 3px #fff;\n  font-size: 0;\n  color: transparent;\n  background-color: #fff;\n  outline: none;\n}\n.mobile-camera-action-capture:active {\n  background-color: #777;\n}\n.mobile-camera video::-webkit-media-controls {\n  display: none;\n}\n@media (orientation: landscape) {\n  .mobile-camera {\n    animation: slide-in-landscape ease forwards 0.3s;\n  }\n  .mobile-camera-preview,\n  .mobile-camera-viewfinder {\n    flex-direction: row;\n  }\n  .mobile-camera-slide-out {\n    animation: slide-in-landscape reverse ease forwards 0.2s;\n  }\n  .mobile-camera-viewfinder-video-container,\n  .mobile-camera-preview-image-container {\n    flex-direction: row;\n  }\n  .mobile-camera-viewfinder-video {\n    width: 133vh;\n    height: 100%;\n  }\n  .mobile-camera-preview-image {\n    width: auto;\n    height: 100%;\n  }\n  .mobile-camera-action-container {\n    width: 120px;\n    height: 100%;\n    flex-direction: column;\n  }\n  .mobile-camera-action-left,\n  .mobile-camera-action-right {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .mobile-camera-action-left {\n    top: auto;\n    bottom: 50px;\n  }\n  .mobile-camera-action-right {\n    top: 50px;\n    right: auto;\n  }\n}\n");

/**
 * 拍照组件，需要先确保能获得 MediaStream 之后再渲染此组件（组件来源 SC 组件 MobileCamera）
 */
var MobileCamera = function (props) {
    var stream = props.stream, onFinish = props.onFinish, onCancel = props.onCancel, onBeforeCapture = props.onBeforeCapture, onRecapture = props.onRecapture, renderSticker = props.renderSticker;
    // 挂载视频流
    var videoRef = React.useRef(null);
    React.useEffect(function () {
        if (stream && videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.controls = false;
        }
    }, [stream, videoRef.current]);
    React.useEffect(function () {
        if (videoRef.current && PlatformUtil.isIOS() && (PlatformUtil.isWeChat() || PlatformUtil.isMiniProgram())) {
            var loadedHandler_1 = function () {
                var _a, _b;
                (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.click();
                (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.play();
            };
            videoRef.current.onloadeddata = loadedHandler_1;
            setTimeout(function () {
                var _a, _b;
                if ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.onloadeddata) {
                    loadedHandler_1();
                }
                if ((_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.onloadeddata) {
                    videoRef.current.onloadeddata = null;
                }
            });
        }
    });
    // 拍照后，已经拍下的图片 base64 data URI
    var _a = React.useState(null), image = _a[0], setImage = _a[1];
    // 是否显示态，拍摄完成或取消后会置为隐藏态
    var _b = React.useState(true), visible = _b[0], setVisible = _b[1];
    // 取景器点击拍照，由于取景器的 4:3 是 CSS 展示的假的，这里需要把当前帧手动裁剪成 4:3，注意横竖屏两种情况
    var onViewfinderCapture = React.useCallback(function (video) {
        var isLandscape = window.innerWidth > window.innerHeight;
        var videoWidth = video.videoWidth, videoHeight = video.videoHeight;
        var width = isLandscape ? 1280 : 960;
        var height = isLandscape ? 960 : 1280;
        var canvas = document.createElement('canvas');
        var coverDivider = Math.max(width / videoWidth, height / videoHeight);
        var drawWidth = videoWidth * coverDivider;
        var drawHeight = videoHeight * coverDivider;
        var left = (width - drawWidth) / 2;
        var top = (height - drawHeight) / 2;
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(video, left, top, drawWidth, drawHeight);
        setImage(canvas.toDataURL('jpg', 0.8));
    }, [image]);
    // 取景器点击取消
    var onViewfinderCancel = React.useCallback(function () {
        setVisible(false);
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel]);
    // 预览器点击插入
    var onClickFinish = React.useCallback(function () {
        setVisible(false);
        onFinish === null || onFinish === void 0 ? void 0 : onFinish(dataURLToBlob(image));
        setImage(null);
    }, [image, onFinish]);
    var onClickRecapture = React.useCallback(function () {
        setImage(null);
        onRecapture === null || onRecapture === void 0 ? void 0 : onRecapture();
    }, [onRecapture]);
    var stricker = (typeof renderSticker === 'function' && visible) ? (React__default.createElement("div", { className: "mobile-camera-stricker-layer" }, renderSticker())) : null;
    if (!visible) {
        return React__default.createElement("div", { className: "mobile-camera mobile-camera-slide-out" });
    }
    else {
        return React__default.createElement("div", { className: "mobile-camera" }, image ? React__default.createElement("div", { className: "mobile-camera-preview" },
            React__default.createElement("div", { className: "mobile-camera-preview-image-container" },
                React__default.createElement("img", { className: "mobile-camera-preview-image", src: image }),
                stricker),
            React__default.createElement("div", { className: "mobile-camera-action-container" },
                React__default.createElement("button", { className: "mobile-camera-action-left", onClick: onClickRecapture }, "\u91CD\u62CD"),
                React__default.createElement("button", { className: "mobile-camera-action-right", onClick: onClickFinish }, "\u63D2\u5165"))) : React__default.createElement("div", { className: "mobile-camera-viewfinder" },
            React__default.createElement("div", { className: "mobile-camera-viewfinder-video-container" },
                React__default.createElement("video", { className: "mobile-camera-viewfinder-video", autoPlay: true, playsInline: true, ref: videoRef }),
                stricker),
            React__default.createElement("div", { className: "mobile-camera-action-container" },
                React__default.createElement("button", { className: "mobile-camera-action-left", onClick: onViewfinderCancel }, "\u53D6\u6D88"),
                React__default.createElement("button", { className: "mobile-camera-action-capture", onClick: function () {
                        if ((onBeforeCapture === null || onBeforeCapture === void 0 ? void 0 : onBeforeCapture(videoRef.current)) === false) {
                            return;
                        }
                        onViewfinderCapture === null || onViewfinderCapture === void 0 ? void 0 : onViewfinderCapture(videoRef.current);
                    } }, "\u62CD\u6444"))));
    }
};
var globalStream;
/**
 * 使用相机组件进行拍照
 */
var pickImageFromCamera = function (_a) {
    var _b = _a === void 0 ? {} : _a, streamPassIn = _b.stream, renderSticker = _b.renderSticker, onBeforeCapture = _b.onBeforeCapture, onError = _b.onError, onFinish = _b.onFinish, onCancel = _b.onCancel, onRecapture = _b.onRecapture;
    return __awaiter(void 0, void 0, void 0, function () {
        var MountId, container, stream_1, _c, e_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    MountId = 'hideImgCamera';
                    container = document.getElementById(MountId);
                    if (!container) {
                        container = document.createElement('div');
                        container.id = MountId;
                        document.body.appendChild(container);
                    }
                    container.style.display = 'block';
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    _c = streamPassIn;
                    if (_c) return [3 /*break*/, 3];
                    return [4 /*yield*/, getCameraStream({ onError: onError })];
                case 2:
                    _c = (_d.sent());
                    _d.label = 3;
                case 3:
                    stream_1 = _c;
                    globalStream = stream_1;
                    // 渲染相机组件
                    return [2 /*return*/, new Promise(function (resolve) {
                            var cleanUp = function () {
                                stopCameraStream(stream_1);
                                globalStream = null;
                                ReactDOM.unmountComponentAtNode(container);
                            };
                            ReactDOM.render(React__default.createElement(MobileCamera, {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                //@ts-ignore
                                stream: stream_1,
                                onFinish: function (file) {
                                    resolve(file);
                                    onFinish === null || onFinish === void 0 ? void 0 : onFinish(file);
                                    cleanUp();
                                },
                                onCancel: function () {
                                    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                                    cleanUp();
                                },
                                renderSticker: renderSticker,
                                onBeforeCapture: onBeforeCapture,
                                onRecapture: onRecapture
                            }), container);
                        })];
                case 4:
                    e_1 = _d.sent();
                    return [2 /*return*/, Promise.reject(e_1)];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var takePhotoWithSticker = function (_a) {
    var _b = _a === void 0 ? {} : _a, renderSticker = _b.renderSticker, onBeforeCapture = _b.onBeforeCapture, onCancel = _b.onCancel, onFinish = _b.onFinish, onRecapture = _b.onRecapture, onError = _b.onError;
    pickImageFromCamera({
        renderSticker: renderSticker,
        onBeforeCapture: onBeforeCapture,
        onError: onError,
        onFinish: onFinish,
        onCancel: onCancel,
        onRecapture: onRecapture,
    }).catch(function (e) {
        Logger.error(e === null || e === void 0 ? void 0 : e.message);
    });
    var update = function (newProps) {
        if (newProps === void 0) { newProps = {}; }
        pickImageFromCamera(__assign({ stream: globalStream, renderSticker: renderSticker,
            onBeforeCapture: onBeforeCapture,
            onError: onError,
            onFinish: onFinish,
            onCancel: onCancel,
            onRecapture: onRecapture }, newProps)).catch(function (e) {
            Logger.error(e === null || e === void 0 ? void 0 : e.message);
        });
    };
    return { update: update };
};

var WxConfigService = /** @class */ (function () {
    function WxConfigService() {
        var _this = this;
        // wx 接口鉴权相关信息
        this.jssdk = SDK_JS_URL;
        this.appId = 'wx46dfe750eef96da7';
        /**
         * 是否已加载wxsdk接口，防止重复请求
         */
        this.hasLoadedSDK = function () {
            if (typeof window.wx !== 'undefined') {
                return true;
            }
        };
        /**
         * 等待dom节点完全挂载成功
         */
        this.waittingForDomMounted = function () {
            return new Promise(function (resolve) {
                var _a;
                if ((_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.readyState) {
                    var readyState = window.document.readyState;
                    if (readyState === 'complete') {
                        resolve();
                    }
                    if (readyState === 'loading' || readyState === 'interactive') {
                        window.document.addEventListener('readystatechange', function () {
                            if (document.readyState === 'complete') {
                                resolve();
                            }
                        });
                    }
                }
                else {
                    resolve();
                }
            });
        };
        /**
         * 加载微信sdk接口
         */
        this.loadJSSDK = function () { return new Promise(function (resolve, reject) {
            if (_this.hasLoadedSDK()) {
                return resolve();
            }
            // 在dom节点上挂在script标签，引入sdk接口
            document.head.appendChild(Object.assign(document.createElement('script'), {
                src: _this.jssdk,
                onload: function () {
                    resolve();
                },
                onerror: function () {
                    reject();
                },
            }));
        }); };
        /**
         * 获取微信签名
         */
        this.getSignature = function () { return new Promise(function (resolve, reject) {
            $.ajax({
                url: wechatSignatureUrl,
                type: 'GET',
                xhrFields: { withCredentials: true },
                data: {
                    url: _this.getPageOriginHref(),
                },
                success: function (data) {
                    resolve(data);
                },
                error: function (error) {
                    reject(error);
                },
            }).then(function (data) {
                var cgicode = data.cgicode, retcode = data.retcode, msg = data.msg;
                if (cgicode !== 0 || retcode !== 0) {
                    return Promise.reject("wx get signature error, retcode: " + retcode + ", error msg: " + msg);
                }
                return Promise.resolve(data);
            });
        }); };
        /**
         * 配置微信接口，返回值是一个异步操作，配置失败将reject，务必catch住错误信息
         * @param apiList api接口名称数组
         */
        this.setWxJsApi = function (apiList) {
            if (!apiList || apiList.length <= 0) {
                return Promise.reject('传入的api接口数组为空');
            }
            if (apiList.length <= 0) {
                return Promise.resolve();
            }
            // 加载jssdk前确保dom节点已经ready
            return _this.waittingForDomMounted()
                // 设置接口前先加载jssdk，如果jssdk已加载会直接resolve，不必担心重复加载问题
                .then(function () { return _this.loadJSSDK(); })
                // 记载完sdk后，将获取签名配置参数，同上，已获取则直接返回参数，不必东西重复获取
                .then(function () { return _this.getSignature(); })
                // 获取参数成功后进行config配置
                .then(function (data) {
                var noncestr = data.noncestr, signature = data.signature, timestamp = data.timestamp;
                return new Promise(function (resolve, reject) {
                    window.wx.config({
                        debug: false,
                        appId: _this.appId,
                        nonceStr: noncestr,
                        timestamp: timestamp,
                        signature: signature,
                        jsApiList: apiList,
                    });
                    window.wx.ready(function () {
                        resolve();
                    });
                    // 失败则reject错误信息
                    window.wx.error(function (res) {
                        reject("wx set jsApiList fail, error msg: " + res);
                    });
                });
            })
                .catch(function (error) {
                Logger.error("setWxJsApi error: " + error);
                tencentDocReport.tdw({
                    opername: 'image_selector',
                    module: 'setWxJsApi',
                    action: 'setWxJsApi_fail',
                    ver5: error
                });
            });
        };
    }
    WxConfigService.prototype.getPageOriginHref = function () {
        try {
            return (localStorage.getItem('tdocs-page-origin-href')
                || window.location.href);
        }
        catch (err) {
            return window.location.href;
        }
    };
    return WxConfigService;
}());

var wxChooseImageJsApi = ['chooseImage', 'getLocalImgData'];
(function (SelectorError) {
    SelectorError[SelectorError["WARNING"] = 0] = "WARNING";
    SelectorError[SelectorError["PERMISSION"] = 1] = "PERMISSION";
    SelectorError[SelectorError["UPLOAD_ERROR"] = 2] = "UPLOAD_ERROR";
    SelectorError[SelectorError["MINIPROGRAM_ERROR"] = 3] = "MINIPROGRAM_ERROR";
    SelectorError[SelectorError["FILE_ERROR"] = 4] = "FILE_ERROR";
    SelectorError[SelectorError["NO_PERMISSION"] = 5] = "NO_PERMISSION";
    SelectorError[SelectorError["NOT_MEMORY"] = 6] = "NOT_MEMORY";
})(exports.SelectorError || (exports.SelectorError = {}));
var QQSDKRetcodeMap = {
    2: exports.SelectorError.NO_PERMISSION,
    3: exports.SelectorError.NOT_MEMORY,
};
/**
 * 图片选择器，包含选图拍照，以及各平台（QQ，微信的小程序及 H5 端）
 * @param selectorConfig 初始化参数，包含是否跳过内置的微信配置操作，默认是不跳过，业务可自行注册 SDK 时可选择跳过
 */
var ImageSelector = /** @class */ (function () {
    function ImageSelector(selectorConfig) {
        var _this = this;
        if (selectorConfig === void 0) { selectorConfig = {
            skipConfig: false,
        }; }
        // 文档App上传图片的数据分片
        this.buffer = new Map();
        this.wxsdkIsReady = false;
        this.wxsdkLoadError = false;
        this.selectorConfig = selectorConfig;
        // 需要跳过注册时，则提前返回
        if (this.shouldSkipConifg())
            return;
        // 注册微信 sdk
        this.wxConfigService = new WxConfigService();
        this.wxConfigService.setWxJsApi(['chooseImage', 'getLocalImgData', 'getClipboardData', 'setClipboardData']).then(function () {
            var _a;
            (_a = _this.wxConfigService) === null || _a === void 0 ? void 0 : _a.setWxJsApi(['chooseImage', 'getLocalImgData', 'getClipboardData', 'setClipboardData']).then(function () {
                Logger.info('ImageSelector: wxsdk is all ready');
                _this.wxsdkIsReady = true;
            });
        }).catch(function (err) {
            var _a;
            (_a = _this.wxConfigService) === null || _a === void 0 ? void 0 : _a.setWxJsApi(['chooseImage', 'getLocalImgData', 'getClipboardData', 'setClipboardData']);
            Logger.error('ImageSelector: wxsdk load error');
            tencentDocReport.tdw({
                opername: 'image_selector',
                module: 'constructor',
                action: 'wxsdk_fail',
                ver5: err
            });
            _this.wxsdkLoadError = false;
        });
    }
    /**
     * 是否需要初始化微信 sdk 接口
     */
    ImageSelector.prototype.shouldSkipConifg = function () {
        // 目前企业微信，腾讯会议APP，腾讯文档APP 中，都不需要注入这些 API
        if (PlatformUtil.isWeWork() || PlatformUtil.isWeMeetApp() || PlatformUtil.isTencentDocApp()) {
            return true;
        }
        // PC 端也不需要加载 wxsdk
        if (!PlatformUtil.isMobile()) {
            return true;
        }
        // 如果配置中声明了跳过注册，则不进行接口注册
        if (this.selectorConfig.skipConfig) {
            return true;
        }
        return false;
    };
    /**
     * 根据小程序接口提供的 localId 获取图片的 blob 数据
     */
    ImageSelector.getImageDataFromLoaclId = function (localId) {
        Logger.info('localId:', localId);
        return new Promise(function (resolve, reject) {
            window.wx.getLocalImgData({
                localId: localId,
                success: function (data) {
                    Logger.info('ImageData:', data);
                    var localData = data.localData;
                    // Android 拿到的数据不能直接使用
                    if (localData.substr(0, 5) !== 'data:') {
                        localData = "data:image;base64," + localData;
                    }
                    var blob = dataURLToBlob(localData);
                    resolve(blob);
                },
                fail: function (error) {
                    tencentDocReport.tdw({
                        opername: 'image_selector',
                        module: 'getImageDataFromLoaclId',
                        action: 'wx_getLocalImgData_fail',
                        ver5: error
                    });
                    return reject("getImageDataFromLoaclId error + " + error);
                },
            });
        });
    };
    /**
     * 调器 QQSDK 选图器，支持多图选择
     * @param selectOption 选图器回调函数选项
     */
    ImageSelector.selectLocalImageFromQQSDK = function (selectOption) {
        var _a = selectOption.maxCount, maxCount = _a === void 0 ? 1 : _a, capture = selectOption.capture, callback = selectOption.callback, errCallback = selectOption.errCallback;
        window.mqq.invoke('media', 'getPicture', {
            source: capture ? 1 : 0,
            front: false,
            max: maxCount,
            outMaxWidth: 800,
            outMaxHeight: 800,
            inMinWidth: 70,
            inMinHeight: 70,
            urlOnly: false,
        }, function (ret, data) {
            if (data === null || data === void 0 ? void 0 : data.length) {
                var blobs_1 = [];
                data.forEach(function (value) {
                    var blob = dataURLToBlob(value.data);
                    blobs_1.push(blob);
                });
                callback(blobs_1);
                return;
            }
            if (QQSDKRetcodeMap[ret]) {
                errCallback({
                    retcode: QQSDKRetcodeMap[ret],
                    msg: ''
                });
                tencentDocReport.tdw({
                    opername: 'image_selector',
                    module: 'selectLocalImageFromQQSDK',
                    action: 'selectLocalImageFromQQSDK_fail',
                    ver7: capture,
                    ver8: ret
                });
            }
        });
    };
    /**
     * 调器 WXSDK 选图器，支持多图选择，由于内部存在异步方法，所以函数返回值是一个 Promise<void>
     * 但是为了保证与其他函数的执行方法一直，该函数依旧采用回调函数而非 then 方法
     * @param selectOption 选图器回调函数选项
     */
    ImageSelector.prototype.selectLoaclImageFromWXSDK = function (selectOption) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var callback, errCallback, capture, localIds, blobs, i, blob, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        callback = selectOption.callback, errCallback = selectOption.errCallback, capture = selectOption.capture;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, this.getLoaclIdFromWXSDK(selectOption)];
                    case 2:
                        localIds = _b.sent();
                        blobs = [];
                        i = 0;
                        _b.label = 3;
                    case 3:
                        if (!(i < localIds.length)) return [3 /*break*/, 6];
                        return [4 /*yield*/, ImageSelector.getImageDataFromLoaclId(localIds[i])];
                    case 4:
                        blob = _b.sent();
                        blobs.push(blob);
                        _b.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 3];
                    case 6:
                        callback(blobs);
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _b.sent();
                        tencentDocReport.tdw({
                            opername: 'image_selector',
                            module: 'selectLoaclImageFromWXSDK',
                            action: 'selectLoaclImageFromWXSDK_fail',
                            ver5: (_a = err_1) === null || _a === void 0 ? void 0 : _a.message,
                            ver6: selectOption.useDefault,
                            ver7: capture
                        });
                        // 失败时，使用 H5 选图拍照作为兜底
                        if (selectOption.useDefault) {
                            capture
                                ? this.getPickImageFromCamera(selectOption)
                                : ImageSelector.getImageFileH5(selectOption);
                        }
                        else {
                            errCallback({
                                retcode: exports.SelectorError.MINIPROGRAM_ERROR,
                                msg: err_1,
                            });
                        }
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 使用 WXSDK 调起拍照或者选图器获取 localId 数组
     * @param selectOption 选图器参数选项
     */
    ImageSelector.prototype.getLoaclIdFromWXSDK = function (selectOption) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, maxCount, capture;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = selectOption.maxCount, maxCount = _a === void 0 ? 1 : _a, capture = selectOption.capture;
                        if (!(this.wxConfigService && !this.wxsdkIsReady)) return [3 /*break*/, 2];
                        Logger.info('reuse wxsdk');
                        return [4 /*yield*/, this.wxConfigService.setWxJsApi(['chooseImage', 'getLocalImgData', 'getClipboardData', 'setClipboardData'])];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            window.wx.chooseImage({
                                count: maxCount,
                                sizeType: ['original', 'compressed'],
                                sourceType: capture ? ['camera'] : ['album'],
                                success: function (res) {
                                    var _a;
                                    resolve((_a = res.localIds) !== null && _a !== void 0 ? _a : res.tempFilePaths);
                                },
                                fail: function (error) {
                                    tencentDocReport.tdw({
                                        opername: 'image_selector',
                                        module: 'getLoaclIdFromWXSDK',
                                        action: 'wx_chooseImage_fail',
                                        ver5: error
                                    });
                                    return reject("getLoaclIdFromWXSDK error + " + error);
                                },
                            });
                        })];
                }
            });
        });
    };
    /**
     *
     * @param capture 是否是拍照，false 代表是选图
     * @param callBack 成功选图/拍照回调，返回的都是一个 url 字符串数组
     * @param errorCallback 失败回调，返回一个 msg 字符串以及一个数字标志
     * @param maxCount 最大选图数量
     */
    ImageSelector.selectImageFromWeWorkSDK = function (capture, callBack, errorCallback, maxCount) {
        var _a, _b;
        if (maxCount === void 0) { maxCount = 1; }
        try {
            if (capture) {
                (_a = window.tdocs) === null || _a === void 0 ? void 0 : _a.openCamera({
                    success: function (img) { return callBack([img]); },
                    fail: function (err, code) { return errorCallback(err, code); },
                });
                return;
            }
            (_b = window.tdocs) === null || _b === void 0 ? void 0 : _b.chooseImage({
                max_count: maxCount,
                success: function (dataMap) { return callBack(dataMap.imgList); },
                fail: function (err, code) { return errorCallback(err, code); },
            });
            return;
        }
        catch (err) {
            errorCallback(err, 0);
        }
    };
    /**
     * 根据平台选择合适的选图器/相机，支持多图选择
     * @param selectOption 选图器/相机回调函数选项
     */
    ImageSelector.prototype.selectLocalImageFile = function (selectOption) {
        var _a, _b;
        selectOption = __assign(__assign({}, selectOption), { useDefault: (_a = selectOption.useDefault) !== null && _a !== void 0 ? _a : true, isTencentAppMultiFile: (_b = selectOption.isTencentAppMultiFile) !== null && _b !== void 0 ? _b : true });
        // 尽管企业微信端不会走到这里了，但是为了避免异常，走一下H5拍照选图（或者必须使用 H5 选择器的情况）
        if (PlatformUtil.isWeWork() || selectOption.shouldUseH5Selector) {
            // 安卓拍照使用 H5 选择器有机型兼容问题，优先用 sc 拍照，sc 拍照失败的话，内部也会兜底到 H5 选择器
            if (PlatformUtil.isAndroid() && selectOption.capture) {
                this.getPickImageFromCamera(selectOption);
                return;
            }
            ImageSelector.getImageFileH5(selectOption);
            return;
        }
        // 是否是 QQH5 且支持 mqq 接口
        var isSupportQQH5 = PlatformUtil.isQQ() && !PlatformUtil.isQQMiniProgram()
            && window.mqq && window.mqq.invoke && PlatformUtil.isMobile() && !PlatformUtil.isWeiYunApp();
        // 是否是 WX 平台且支持 wx 接口
        var isSupportWx = !PlatformUtil.isQQ() && window.wx && PlatformUtil.isWXFamily()
            && !PlatformUtil.isTencentDocsApp() && PlatformUtil.isMobile();
        // 是否支持 APP 端多图能力
        var isSupportMultiFile = (PlatformUtil.isTencentDocApp() && PlatformUtil.checkTencentDocAppVersionSupportFunction('2.11.8'));
        // 选图时，支持 APP 多图就走多图逻辑
        if (selectOption.isTencentAppMultiFile && !selectOption.capture && isSupportMultiFile) {
            Logger.info('ImageSelector: start nativeMulti selector');
            this.selectNativeImagePicker(selectOption);
            return;
        }
        // QQH5 均走小程序 sdk
        if (isSupportQQH5) {
            Logger.info('ImageSelector: start qqsdk selector');
            ImageSelector.selectLocalImageFromQQSDK(selectOption);
            return;
        }
        // 微信平台除了 IOS拍照 外均采用微信Jssdk接口
        if (isSupportWx && !(PlatformUtil.isIOS() && selectOption.capture)) {
            Logger.info('ImageSelector: start wxsdk selector');
            this.selectLoaclImageFromWXSDK(selectOption);
            return;
        }
        // 除开上述情况外，IOS 所有平台以及 Android APP 均采用 H5 标签
        if (PlatformUtil.isIOS() || (PlatformUtil.isAndroid() && PlatformUtil.isTencentDocsApp())) {
            Logger.info('ImageSelector: start H5 selector');
            ImageSelector.getImageFileH5(selectOption);
            return;
        }
        //  Android 拍照的其余情况走相机组件
        if (selectOption.capture && PlatformUtil.isAndroid()) {
            Logger.info('ImageSelector: start sc camera');
            this.getPickImageFromCamera(selectOption);
            return;
        }
        // H5 选图拍照做最后兜底
        Logger.info('ImageSelector: start H5 selector(save)');
        ImageSelector.getImageFileH5(selectOption);
    };
    ImageSelector.prototype.getPickImageFromCamera = function (selectOption) {
        pickImageFromCamera().then(function (blob) {
            selectOption.callback([blob]);
        }).catch(function (err) {
            Logger.error('ImageSelector: sc camera error', err);
            tencentDocReport.tdw({
                opername: 'image_selector',
                module: 'getPickImageFromCamera',
                action: 'getPickImageFromCamera_fail',
                ver5: err === null || err === void 0 ? void 0 : err.message,
                ver6: selectOption.useDefault
            });
            if (selectOption.useDefault) {
                ImageSelector.getImageFileH5(selectOption);
            }
            else {
                selectOption.errCallback({
                    retcode: -1,
                    msg: '拍照失败(pickImageFromCamera error)'
                });
            }
        });
    };
    // 使用 H5 标签来获取本地图片资源
    ImageSelector.getImageFileH5 = function (selectOption) {
        var _a;
        var MountId = 'hideImgSelector';
        var _b = selectOption.maxCount, maxCount = _b === void 0 ? 1 : _b, capture = selectOption.capture, callback = selectOption.callback, errCallback = selectOption.errCallback;
        var inputObj = document.getElementById(MountId);
        if (!inputObj) {
            inputObj = document.createElement('input');
        }
        inputObj.setAttribute('id', MountId);
        inputObj.setAttribute('type', 'file');
        maxCount > 1 && inputObj.setAttribute('multiple', 'multiple');
        var acceptType = (_a = selectOption.acceptType) !== null && _a !== void 0 ? _a : getH5CaptureAttr(capture);
        inputObj.setAttribute('accept', acceptType);
        inputObj.setAttribute('style', 'display:none');
        if (capture) {
            inputObj.setAttribute('capture', 'camera');
        }
        else {
            inputObj.removeAttribute('capture');
        }
        Logger.info('image_selector: H5 selector set dom finish');
        document.body.appendChild(inputObj);
        if (window.FileReader) {
            $(document)
                .off('change')
                .on('change', '#hideImgSelector', function () {
                if (!this.files || this.files.length <= 0) {
                    errCallback({
                        retcode: exports.SelectorError.FILE_ERROR,
                        msg: 'insertImage error: no files',
                    });
                }
                Logger.info('image_selector: H5 selector finish');
                callback(this.files);
                if (inputObj) {
                    document.body.removeChild(inputObj);
                }
            });
        }
        Logger.info('image selector: H5 selector click');
        inputObj.click();
    };
    /**
     * 调器 APP 端选图器，支持多图选择
     * @param selectOption 选图器回调函数选项
     */
    ImageSelector.prototype.selectNativeImagePicker = function (selectOption) {
        var _this = this;
        var _a;
        var _b = selectOption.maxCount, maxCount = _b === void 0 ? 1 : _b, callback = selectOption.callback, errCallback = selectOption.errCallback, forceAllCompleted = selectOption.forceAllCompleted;
        var blobs = [];
        // 要全全部完成再回调且要求选择图片可以大于 1 张时，如果不支持 3.1.0 版本，则走 H5
        if (forceAllCompleted && maxCount > 1 && !PlatformUtil.checkTencentDocAppVersionSupportFunction('3.1.0')) {
            ImageSelector.getImageFileH5(selectOption);
            return;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        (_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke('docx', 'multipleImagePicker', { max_count: maxCount }, function (dataMap) {
            var retcode = dataMap.retcode, data = dataMap.data, completed = dataMap.completed, patchId = dataMap.patchId, fileId = dataMap.fileId, isAllCompleted = dataMap.isAllCompleted;
            var extension = dataMap.extension ? dataMap.extension : 'png';
            switch (retcode) {
                case 0:
                    if (patchId === 0) {
                        _this.buffer.clear();
                    }
                    // 如果该分片不存在则加入buffer中，存在则不进行操作并上报异常
                    if (!_this.buffer[patchId]) {
                        _this.buffer.set(patchId, data);
                    }
                    else {
                        // 分片重复, 目前重复不中断流程，通过map结构可以解决重复问题，但作为异常需要上报
                        errCallback({
                            retcode: 0,
                            msg: "multipleImagePicker error, fileId: " + fileId + ", patchId: " + patchId + " repeat",
                        });
                    }
                    // 传输完成
                    if (completed) {
                        if (patchId >= _this.buffer.size) {
                            // 分片id（从0计数）大于等于当前buffer的大小，说明分片丢失，中断当前图片的插入流程
                            errCallback({
                                retcode: exports.SelectorError.WARNING,
                                msg: "multipleImagePicker error, fileId: " + fileId + ", patchId/size : " + patchId + "/" + _this.buffer.size + ", image lost",
                            });
                            break;
                        }
                        var totalBuffer_1 = '';
                        _this.buffer.forEach(function (value) {
                            totalBuffer_1 += value;
                        });
                        var blob = dataURLToBlob("data:image/" + extension + ";base64," + totalBuffer_1);
                        blobs.push(blob);
                        // 没有要求一次性处理完毕，则每次单图 completed 都执行 callback，如果 isAllCompleted 为 undefined，说明不支持此字段
                        if (!forceAllCompleted || isAllCompleted === undefined) {
                            callback([blob], isAllCompleted);
                        }
                        else if (isAllCompleted) {
                            // 要求一次性处理完毕，则在 isAllCompleted 为 true 时执行 callback
                            callback(blobs, isAllCompleted);
                        }
                        _this.buffer.clear();
                    }
                    break;
                case 1:
                    errCallback({
                        retcode: exports.SelectorError.PERMISSION,
                        msg: '',
                    });
                    break;
                case 2:
                    errCallback({
                        retcode: exports.SelectorError.UPLOAD_ERROR,
                        msg: '',
                    });
                    break;
            }
        });
    };
    return ImageSelector;
}());

exports.Compressor = Compressor;
exports.Crop = Crop;
exports.CropImageOption = CropImageOption;
exports.ImageOption = ImageOption;
exports.ImageSelector = ImageSelector;
exports.ImageUploader = ImageUploader;
exports.ImageUtil = ImageUtil;
exports.takePhotoWithSticker = takePhotoWithSticker;
exports.wxChooseImageJsApi = wxChooseImageJsApi;
//# sourceMappingURL=index.es2015.js.map
